export enum VPOCombinedActionsTypes {
  FETCH_REQUEST = 'VPO_COMBINED_ACTIONS/FETCH_REQUEST',
  FETCH_SUCCESS = 'VPO_COMBINED_ACTIONS/FETCH_SUCCESS',
  FETCH_FAILURE = 'VPO_COMBINED_ACTIONS/FETCH_FAILURE',
  CLEAR_DATA = 'VPO_COMBINED_ACTIONS/CLEAR_DATA',
}

export interface FetchVPOCombinedActionsRequest {
  type: VPOCombinedActionsTypes.FETCH_REQUEST;
  payload: {
    filters: any;
    append?: boolean;
  };
}

export interface FetchVPOCombinedActionsSuccess {
  type: VPOCombinedActionsTypes.FETCH_SUCCESS;
  payload: {
    data: any;
    append?: boolean;
  };
}

export interface FetchVPOCombinedActionsFailure {
  type: VPOCombinedActionsTypes.FETCH_FAILURE;
  payload: { error: string };
}

export interface ClearVPOCombinedActionsData {
  type: VPOCombinedActionsTypes.CLEAR_DATA;
}

export type VPOCombinedActionsAction =
  | FetchVPOCombinedActionsRequest
  | FetchVPOCombinedActionsSuccess
  | FetchVPOCombinedActionsFailure
  | ClearVPOCombinedActionsData;

export const fetchVPOCombinedActions = (filters: any, append = false): FetchVPOCombinedActionsRequest => ({
  type: VPOCombinedActionsTypes.FETCH_REQUEST,
  payload: { filters, append },
});

export const fetchVPOCombinedActionsSuccess = (data: any, append = false): FetchVPOCombinedActionsSuccess => ({
  type: VPOCombinedActionsTypes.FETCH_SUCCESS,
  payload: { data, append },
});

export const fetchVPOCombinedActionsFailure = (error: string): FetchVPOCombinedActionsFailure => ({
  type: VPOCombinedActionsTypes.FETCH_FAILURE,
  payload: { error },
});

export const clearVPOCombinedActionsData = (): ClearVPOCombinedActionsData => ({
  type: VPOCombinedActionsTypes.CLEAR_DATA,
});